import { code } from 'country-emoji';

// Offset of 🇦 (REGIONAL INDICATOR SYMBOL LETTER A) so a 2-letter ISO code can be
// turned into its flag emoji directly. This covers every valid alpha-2 code,
// including ones country-emoji's dictionary is missing (e.g. SS, CW, BQ, BL, MF, SX).
const REGIONAL_INDICATOR_A = 0x1f1e6;

function codeToFlagEmoji(isoCode) {
  return String.fromCodePoint(
    REGIONAL_INDICATOR_A + isoCode.charCodeAt(0) - 65,
    REGIONAL_INDICATOR_A + isoCode.charCodeAt(1) - 65,
  );
}

let regionNamesInEnglish = null;
let languageNamesInEnglish = null;
try {
  regionNamesInEnglish = new Intl.DisplayNames(['en'], { type: 'region' });
  languageNamesInEnglish = new Intl.DisplayNames(['en'], { type: 'language' });
} catch {
  // Intl.DisplayNames may not be available in all environments (e.g. Cypress Electron).
  // Functions below fall back to returning raw codes when these are null.
}

export function getCountryName(countryCode) {
  if (!regionNamesInEnglish) return countryCode;
  let countryName;
  try {
    countryName = regionNamesInEnglish.of(countryCode);
  } catch {
    countryName = countryCode;
  }
  return countryName;
}

export function getCountryFlag(countryNameOrCode) {
  if (!countryNameOrCode) return '-';
  const input = String(countryNameOrCode).trim();
  // Accept an alpha-2 code directly, otherwise resolve a country name to its code.
  const isoCode = /^[A-Za-z]{2}$/.test(input) ? input.toUpperCase() : code(input);
  if (!isoCode || !/^[A-Za-z]{2}$/.test(isoCode)) return '-';
  return codeToFlagEmoji(isoCode);
}

export function getCountryCode(countryNameOrFlag) {
  const countryCode = code(countryNameOrFlag);
  return countryCode || '-';
}

export function getLanguageName(languageCode) {
  if (!languageNamesInEnglish) return languageCode;
  let languageName;
  try {
    languageName = languageNamesInEnglish.of(languageCode);
  } catch {
    languageName = languageCode;
  }
  return languageName;
}
